import React from 'react';
type TopoLinesProps = {
  className?: string;
};

/**
 * Dibujo técnico de línea (volante con bulones y mira) — el motivo de
 * boletin técnico de los tomos DPS64. Hereda el color via `currentColor`.
 * Conserva el nombre de la plantilla para no tocar la estructura.
 */
export function TopoLines({
  className
}: TopoLinesProps) {
  const bolts = [[180, 120], [162.4, 162.4], [120, 180], [77.6, 162.4], [60, 120], [77.6, 77.6], [120, 60], [162.4, 77.6]];
  return <svg viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" aria-hidden="true" className={className} data-id="element-363" data-mp="3qj8j8b6fuz0u">
      <circle cx="120" cy="120" r="104" strokeDasharray="4 8" data-id="element-364" data-mp="3hhr4ox8oj5e9" />
      <circle cx="120" cy="120" r="80" data-id="element-365" data-mp="3hkd9ip46r6ss" />
      <circle cx="120" cy="120" r="40" data-id="element-366" data-mp="213r8nxcyfzwa" />
      <circle cx="120" cy="120" r="12" data-id="element-367" data-mp="212pjkoz3tcvk" />
      <path d="M120 4v34M120 202v34M4 120h34M202 120h34" data-id="element-368" data-mp="262u54tevcxsn" />
      {bolts.map(([x, y]) => <circle key={`${x}-${y}`} cx={x} cy={y} r="5" data-id="element-369" data-mp="53qngonwmiqb" />)}
    </svg>;
}